import { createServerFn } from "@tanstack/react-start";

export const getSearchServerState = createServerFn({ method: "GET" })
	.validator((data: { query: string }) => {
		if (typeof data.query !== "string" || data.query.length > 2000) {
			throw new Error("Invalid search query");
		}
		return data;
	})
	.handler(async ({ data }) => {
		const { loadSearchServerState } = await import("./search-ssr.server");
		// Algolia SSR state is JSON data; the SDK type also permits opaque values.
		// Keep those broad SDK types out of the server-function serializer contract.
		return JSON.stringify(await loadSearchServerState(data.query));
	});
